export default __webpack_public_path__ + "static/media/chatton13.b47f516f.jpg";